import React from 'react';
import * as Sentry from '@sentry/react';
import Box from 'Components/Atoms/Box';
import Typography from 'Components/Atoms/Typography';

type Props = {
  children: React.ReactNode;
  resetKey?: string;
};

type State = {
  error: null | Error;
  resetKey?: string;
};

class ReservationSideBarErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null, resetKey: this.props.resetKey };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  static getDerivedStateFromProps(props: Props, state: State): State | null {
    if (props.resetKey !== state.resetKey) {
      return { error: null, resetKey: props.resetKey };
    }
    return null;
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Catching here keeps the error from reaching the global boundary in
    // index.js, which is the one that reports to Sentry.
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info.componentStack } },
    });
    console.error('ReservationSideBar render failed', error, info);
  }

  render() {
    const { error } = this.state;

    if (error) {
      return (
        <Box className="reservation-field" style={{ padding: '16px 16px' }}>
          <Typography variant="text-2" color="error" block>
            Diese Reservierung konnte nicht geladen werden. Bitte Seite neu
            laden oder eine andere Reservierung wählen.
          </Typography>
          <Typography
            variant="text-4"
            color="subdued"
            block
            style={{ marginTop: 8 }}
          >
            {error.message}
          </Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ReservationSideBarErrorBoundary;
